import * as React from 'react';
import { connect } from 'react-redux';
import * as TIModule from 'Modules/TerminalInstallationModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { withTranslation  } from 'react-i18next';
import { CustomProps, IParentDetailsProps, ParentDetails } from 'components/Layout/DetailsSidebar/ParentDetails';
import { RootState } from 'Redux/Reducers/_RootReducer';
import { TerminalInstallationSelectors } from 'Redux/Selectors/TerminalInstallationSelectors';
import * as Dictionary from '../../../Models/Dictionary';
import { EnumTypes as PageEnumTypes } from '../../../Models/EnumTypes/PageEnumTypes';
import * as UserModule from "Modules/UserModule";
import {EnumTypes} from "Models/EnumTypes/UserEnumTypes";

interface IP extends IParentDetailsProps {
    history: any;
}
type ConnectedP = {
    activeEl: TIModule.Types.TerminalInstallationOrderDto;
    user: UserModule.Types.UserDto;
};
type DispatchedP = {
    setActiveEl: (terminalInstalationId: number) => Function;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    t?: (key: string) => string;
    cancelOrder: (terminalInstallationOrdersId: number) => void;
    confirmInstallation: (terminalInstallationOrdersId: number) => void;
    getTerminalInstallationReportFile: (terminalInstallationOrdersId: number) => void;
    cancelInstallationDate: (terminalInstallationOrdersId: number) => void;
};

type S = {};

class TerminalInstallationListDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    public getCustomProps(): CustomProps {
        const { activeEl } = this.props;
        return {
            ...(this.props as any),
            redirectUrlEdit: `${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/${activeEl ? activeEl.id : ''}`,
            redirectUrlAdd: `${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/add`,
            labelAdd: this.props.t('tables:add_order'),
            labelEdit: this.props.t('tables:edit_order'),
            extrnalRender: () => this.extrnalRender()
        };
    }

    protected setInstallationDate() {
        if (!this.editInstallationDateIsDisabled()) {
            const { setActiveEl, activeEl } = this.getCustomProps();
            setActiveEl(null);
            this.props.history.push(`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/${activeEl.id}/installation-date`);
        }
    }

    protected generateAssemblyReport() {
        if (!this.generateAssemblyReportIsDisabled()) {
            const { activeEl } = this.getCustomProps();
            this.props.getTerminalInstallationReportFile(activeEl.id);
        }
    }

    protected cancelInstallationDate() {
        const { showPopup, activeEl, cancelInstallationDate } = this.props;
        const { PopupType } = ViewManagementModule.VMEnumTypes;

        if (!this.cancelInstallationDateIsDisabled()) {
            showPopup({
                type: PopupType.CANCEL_DATE,
                confirmCallback: async () => {
                    await cancelInstallationDate(activeEl.id);
                }
            });
        }
    }

    protected cancelOrder() {
        const { showPopup, setActiveEl, activeEl, cancelOrder } = this.props;
        const { PopupType } = ViewManagementModule.VMEnumTypes;

        if (!this.cancelOrderIsDisabled()) {
            showPopup({
                type: PopupType.CANCEL_ORDER,
                confirmCallback: async () => {
                    await cancelOrder(activeEl.id);
                    setActiveEl(null);
                }
            });
        }
    }

    protected confirmInstallation() {
        const { showPopup, activeEl, confirmInstallation } = this.props;
        const { PopupType } = ViewManagementModule.VMEnumTypes;

        if (!this.confirmInstallationIsDisabled()) {
            showPopup({
                type: PopupType.CONFIRM_ORDER,
                confirmCallback: async () => {
                    await confirmInstallation(activeEl.id);
                }
            });
        }
    }

    private extrnalRender() {
        const { t, activeEl } = this.getCustomProps();

        const classNameInstallationDate = this.editInstallationDateIsDisabled() ? ' details-right__dashboard-item--disabled ' : '';
        const classNameCancelInstallationDate = this.cancelInstallationDateIsDisabled() ? ' details-right__dashboard-item--disabled ' : '';
        const classNameGenerateAssemblyReport = this.generateAssemblyReportIsDisabled() ? ' details-right__dashboard-item--disabled ' : '';
        const classNameCancelOrder = this.cancelOrderIsDisabled() ? ' details-right__dashboard-item--disabled ' : '';
        const classNameConfirmInstallation = this.confirmInstallationIsDisabled() ? ' details-right__dashboard-item--disabled ' : '';

        return (
            <>
                <div className={`details-right__dashboard-item ${classNameInstallationDate}`} onClick={() => this.setInstallationDate()} data-testid="menu-change-date">
                    {activeEl && (activeEl as TIModule.Types.TerminalInstallationOrderDto).status != TIModule.TerminalInstallationEnumTypes.Status.NEW ? (
                        <>
                            <img src={`/images/icons/calender_btn.svg`} alt="" className="details-right__dashboard-icon"/> <span>{t('tables:edit_installation_date')}</span>
                        </>
                    ) : (
                        <>
                            <img src={`/images/icons/calender_btn.svg`} alt="" className="details-right__dashboard-icon"/> <span>{t('tables:set_installation_date')}</span>{' '}
                        </>
                    )}
                </div>

                <div className={`details-right__dashboard-item ${classNameCancelInstallationDate}`} onClick={() => this.cancelInstallationDate()}>
                    <img src={`/images/icons/garbage.svg`} alt="" className="details-right__dashboard-icon"/>
                    <span>{t('tables:cancel_installation_date')}</span>
                </div>

                <div className={`details-right__dashboard-item ${classNameGenerateAssemblyReport}`} onClick={() => this.generateAssemblyReport()}>
                    <div className={'details-right__dashboard-icon'}>
                        <img src={`/images/icons/pdf.svg`} alt="" className="details-right__dashboard-icon--mini"/>
                    </div>
                    <span>{t('tables:generate_assembly_report')}</span>
                </div>

                <div className={`details-right__dashboard-item mt-55 ${classNameConfirmInstallation}`} onClick={() => this.confirmInstallation()}>
                    <img src={`/images/icons/status_succes.svg`} alt="" className="details-right__dashboard-icon"/>
                    <span>{t('tables:confirm_installation')}</span>
                </div>

                <div className={`details-right__dashboard-item ${classNameCancelOrder}`} onClick={() => this.cancelOrder()}>
                    <img src={`/images/icons/red_cros.svg`} alt="" className="details-right__dashboard-icon"/>
                    <span>{t('tables:cancel_order')}</span>
                </div>
            </>
        );
    }

    protected editButtonIsDisabled() {

      if (this.isExternalUser()) {
        return true
      }
        let isDisabled = super.editButtonIsDisabled();

        if (!isDisabled) {
            const { activeEl } = this.getCustomProps();
            isDisabled = activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.CANCELLED
                || activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED
        }

        return isDisabled;
    }

    protected editInstallationDateIsDisabled() {
        const { activeEl } = this.getCustomProps();
        return !activeEl
            || (activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED)
            || activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.CANCELLED
            || activeEl.status != TIModule.TerminalInstallationEnumTypes.Status.NEW && this.isExternalUser()
    }

    protected cancelInstallationDateIsDisabled() {
        if (this.isExternalUser()) {
          return true
        }

        const { activeEl } = this.getCustomProps();
        return !activeEl || activeEl.status !== TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED;
    }

    protected generateAssemblyReportIsDisabled() {
      if (this.isExternalUser()) {
        return true
      }
        const { activeEl } = this.getCustomProps();
        return (
            !activeEl ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.NEW ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.CANCELLED
        );
    }

    protected cancelOrderIsDisabled() {
      if (this.isExternalUser()) {
        return true
      }
        const { activeEl } = this.getCustomProps();
        return !activeEl || activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_FINISHED || activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.CANCELLED;
    }

    protected confirmInstallationIsDisabled() {

      if (this.isExternalUser()) {
        return true
      }
        const { activeEl } = this.getCustomProps();
        return (
            !activeEl ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.NEW ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_DATE_CONFIRMED ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED ||
            activeEl.status == TIModule.TerminalInstallationEnumTypes.Status.CANCELLED
        );
    }
}

function mapStateToProps(state: RootState): ConnectedP {
    return {
        activeEl: TerminalInstallationSelectors.getActiveTerminalInstallation(state),
        user: state.userStore?.user
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        setActiveEl: (terminalInstalationId: number) => dispatch(TIModule.Actions.setActive(terminalInstalationId)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        cancelOrder: (terminalInstallationOrdersId: number) => dispatch(TIModule.Actions.cancelTerminalInstallationOrders(terminalInstallationOrdersId)),
        confirmInstallation: (terminalInstallationOrdersId: number) => dispatch(TIModule.Actions.confirmTerminalInstallation(terminalInstallationOrdersId)),
        getTerminalInstallationReportFile: (terminalInstallationOrdersId: number) => dispatch(TIModule.Actions.getTerminalInstallationReportFile(terminalInstallationOrdersId)),
        cancelInstallationDate: (terminalInstallationOrdersId: number) => dispatch(TIModule.Actions.cancelInstallationDate(terminalInstallationOrdersId))
    };
}
export default withTranslation (['carDetails', 'tables', 'form'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(TerminalInstallationListDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/TerminalInstallationListDetails.tsx